import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-286">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-brand-dark/40 backdrop-blur-sm z-50" aria-hidden="true" data-id="element-287" />
          <div className="fixed inset-0 flex items-center justify-center z-50 pointer-events-none p-4 sm:p-6" data-id="element-288">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 300
        }} className="bg-brand-cream w-full max-w-4xl max-h-[90vh] overflow-y-auto rounded-xl shadow-2xl pointer-events-auto relative" role="dialog" aria-modal="true" data-id="element-289">
              <button onClick={onClose} className="absolute top-4 right-4 p-2 bg-white/80 backdrop-blur-md rounded-full text-brand-dark hover:bg-brand-beige transition-colors z-10" aria-label="Close modal" data-id="element-290">
                <X className="w-5 h-5" data-id="element-291" />
              </button>
              {children}
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}